import { format, getDaysInMonth, getYear } from 'date-fns';

import { firstLetterToUppercase } from 'lib/stringUtilities';
import { sortByProps } from '../../../lib/sortByProp.js';

const fillDayGaps = (data) => {
  if (data.length) {
    const filterValue = 'Total';
    const totalRemoved = data.filter((item) => item.Day !== filterValue);
    if (totalRemoved[0] && totalRemoved[0].Day) {
      const dt = new Date(totalRemoved[0].Day);
      const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
      const daysInMonth = getDaysInMonth(dtDateOnly);
      const year = getYear(dtDateOnly);
      const month = format(dtDateOnly, 'MM');
      const mapDates = totalRemoved.reduce((all, item) => {
        all[item.Day] = item;
        return all;
      }, {});
      const valuesToMapToDatePadding = Object.fromEntries(
        Object.entries({ ...totalRemoved[0] }).map((item) => {
          item[1] = 0;
          return item;
        })
      );

      for (let i = 1; i < daysInMonth + 1; i++) {
        const day = i < 10 ? `0${i}` : i;
        const date = `${year}-${month}-${day}`;
        if (!mapDates[date]) {
          mapDates[date] = { ...valuesToMapToDatePadding, Day: date };
        }
      }
      const final = Object.entries(mapDates).map((item) => ({ ...item[1], Date: item[1].Day }));
      return final.sort(sortByProps((n) => new Date(n.Date), ['Date']));
    }
  }
  return data;
};

export const formatGraphData = (data, lineKey, dataKey, compareData, secondaryFriendly = undefined) => {
  const paddedData = fillDayGaps(data);
  const formattedForGraphs = (paddedData || []).map((item) => {
    let returnObj = { ...item, [lineKey]: item[dataKey] };
    if (secondaryFriendly) {
      returnObj[secondaryFriendly] = item[dataKey];
    }
    return returnObj;
  });
  if ((compareData || []).length && (formattedForGraphs || []).length) {
    const paddedDataComparisonData = fillDayGaps(compareData);
    (paddedDataComparisonData || []).forEach((item, i) => {
      const secondaryLineKeyName = `${firstLetterToUppercase(secondaryFriendly || lineKey || '')} (Compared Date)`;
      formattedForGraphs[i][secondaryLineKeyName] = item[dataKey];
    });
  }

  return formattedForGraphs;
};
